import store_operation from "@/store/mods/caisse/operations"
import $ from 'jquery'

export default {
    name: 'manage-demande-autorisation',
    components: {},
    props: {
        action_toggler: {
            type: Number,
            default: 0
        },
        demande_id: {
            type: Number,
            default: 0
        },
        user_info: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            liste_prestations: [],
            is_empty: false,
            is_loading: true,
            is_load_error: false,
            all_checked: true,
            demandes_validees: [],
            can_confirm: false,
            etat_demande: 0,
            is_op_confirm: true,
            msg_err: '',
            save_loading: false
        }
    },

    watch: {
        action_toggler() {
            this.is_op_confirm = true
            this.msg_err = ''
            this.can_confirm = false
            this.fetchDetailDemandeAutorisation()
        }
    },
    
    computed: {

    },

    mounted() {

    },

    methods: {
        fetchDetailDemandeAutorisation() {
            this.is_loading = true
            this.is_load_error = false
            store_operation.getDetailDemandeAutorisation(this.demande_id).then((response) => {
                this.liste_prestations = response 

                if (this.liste_prestations.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                this.is_loading = false

                setTimeout(() => {
                    this.checkAll()
                }, 100);
            }).catch(() => {
                this.is_loading = false
                this.is_load_error = true
            })
        },

        checkAll() {
            this.demandes_validees = [] 
            let is_checked = $('#check-items').is(":checked")
            console.log("is_checked : ",is_checked);
            
            if (is_checked) {
                this.liste_prestations.forEach(el => {
                    if (el.etat_demande_autorisation == 1) {
                        this.demandes_validees.push(el)
                    }
                });
                this.all_checked = true
            } 
            else {
                this.demandes_validees = []  
                this.all_checked = false
            }
        },

        confirmerDemande(action) {
            this.can_confirm = true
            this.etat_demande = (action == 'autoriser')?2:3
        },

        valider(selector) {
            const confirm = document.getElementById(selector);
            if (!confirm.checked) {
                this.is_op_confirm = false
                return
            }

            console.log(">> ",this.demandes_validees);
            const data = {
                demandes_validees: this.demandes_validees,
                demande_id: this.demande_id,
                user_id: this.user_info.user_id,
                user: this.user_info.name,
                etat_demande: this.etat_demande
            }
            this.save_loading = true
            store_operation.validerDemandeAutorisation(data).then((response) => {
                if (response.success) {
                    this.$refs.mng_demande.click()
                    this.successToast(response.message)

                    this.$emit("emitRefreshDemandeAutorisation")  
                } else {
                    this.msg_err = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_err = "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer plus tard."
            })
        },

        onConfirmOP() {
            this.is_op_confirm = true
        },

        scrollTo(anchor) {
            setTimeout(() => {
                let scroll_value = $('#'+anchor).offset().top
                $('#scrll-to-anchor').animate({
                    scrollTop: scroll_value
                }, 800, function() {});
            }, 1000);
        },

        handleTaux(index) {
            let input_taux = document.getElementById('tx-'+index)

            let taux = input_taux.value
            taux = this.cleanNumber(taux)

            if (taux === '') {
                this.liste_prestations[index].taux_assurance = 0
            }
            this.liste_prestations[index].taux_assurance = taux
        },

        handleBA(index) {
            let input_ba = document.getElementById('ba-'+index)

            let base_assur = input_ba.value
            base_assur = this.cleanNumber(base_assur)

            if (base_assur === '') {
                this.liste_prestations[index].base_assurance = 0
            }
            this.liste_prestations[index].base_assurance = base_assur
        },
    }
}